import { AmmunitionStockService } from './ammunition-stock.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { AMMUNITION_STOCK_TYPE, AmmunitionStock } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class AmmunitionStockResolverBase implements Resolve<AmmunitionStock> {

  constructor(protected service: AmmunitionStockService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<AmmunitionStock> {
    const key: number = AMMUNITION_STOCK_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



